<template>
  <div> 电子档案室 首页 </div>
</template>
<style lang="less" type="text/less" scoped></style>
<script>
export default {
  name: 'DatabaseHome'
}
</script>
